// origen: D=Doméstico, T=Transnacional, G=Gobierno, P=Política
const CANAL_DATA = {
  'canal-5': {
    canal: 'CANAL 5',
    total: 109295015,
    totalSpots: 138574,
    data: [
      { pos: 1,  anunciante: 'GRUPO INTUR', inv: 16642357, spots: 13614, origen: 'D' },
      { pos: 2,  anunciante: 'GENOMMA LAB', inv: 8977357, spots: 7674, origen: 'T' },
      { pos: 3,  anunciante: 'LOTELHSA', inv: 8182324, spots: 13789, origen: 'D' },
      { pos: 4,  anunciante: 'CORPORACION DINANT', inv: 4578097, spots: 7050, origen: 'D' },
      { pos: 5,  anunciante: 'SUPERMERCADOS LA COLONIA', inv: 3635881, spots: 2303, origen: 'D' },
      { pos: 6,  anunciante: 'SERCOM DE HONDURAS', inv: 3394575, spots: 3794, origen: 'T' },
      { pos: 7,  anunciante: 'FARMACITY', inv: 3129816, spots: 2904, origen: 'D' },
      { pos: 8,  anunciante: 'PROIMA HONDURAS', inv: 2307674, spots: 1788, origen: 'D' },
      { pos: 9,  anunciante: 'UNICOMER', inv: 2275153, spots: 4770, origen: 'T' },
      { pos: 10, anunciante: 'BANPAIS', inv: 2165093, spots: 1814, origen: 'D' },
      { pos: 11, anunciante: 'NESTLE', inv: 2018271, spots: 2494, origen: 'T' },
      { pos: 12, anunciante: 'FARMA FACIL', inv: 1957361, spots: 3248, origen: 'D' },
      { pos: 13, anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 1816406, spots: 3151, origen: 'D' },
      { pos: 14, anunciante: 'CARRION', inv: 1775225, spots: 1842, origen: 'D' },
      { pos: 15, anunciante: 'FARMAMEDICA', inv: 1773185, spots: 3195, origen: 'T' },
      { pos: 16, anunciante: 'BAC CREDOMATIC', inv: 1726380, spots: 1838, origen: 'T' },
      { pos: 17, anunciante: 'PEPE JEANS', inv: 1337593, spots: 807, origen: 'D' },
      { pos: 18, anunciante: 'CELTEL', inv: 1322381, spots: 2417, origen: 'T' },
      { pos: 19, anunciante: 'PASINERVA', inv: 1197241, spots: 3036, origen: 'D' },
      { pos: 20, anunciante: 'DIUNSA', inv: 1181054, spots: 1814, origen: 'D' },
      { pos: 21, anunciante: 'INFASA', inv: 1137439, spots: 3265, origen: 'D' },
      { pos: 22, anunciante: 'BANCO ATLANTIDA', inv: 1123084, spots: 1649, origen: 'D' },
      { pos: 23, anunciante: 'YUUJU APP', inv: 1017597, spots: 581, origen: 'D' },
      { pos: 24, anunciante: 'UNIMERC', inv: 999192, spots: 1212, origen: 'T' },
      { pos: 25, anunciante: 'CENTRO OFTALMOLOGICO SANTA LUCIA', inv: 998727, spots: 1985, origen: 'D' },
    ],
  },
  'hch': {
    canal: 'HCH',
    total: 58408059,
    totalSpots: 171886,
    data: [
      { pos: 1,  anunciante: 'BAC CREDOMATIC', inv: 3354468, spots: 6200, origen: 'T' },
      { pos: 2,  anunciante: 'SERCOM DE HONDURAS', inv: 3299132, spots: 13344, origen: 'T' },
      { pos: 3,  anunciante: 'CELTEL', inv: 2201761, spots: 5004, origen: 'T' },
      { pos: 4,  anunciante: 'BANCO ATLANTIDA', inv: 1610774, spots: 5581, origen: 'D' },
      { pos: 5,  anunciante: 'PARTIDO LIBRE', inv: 1503318, spots: 1565, origen: 'P' },
      { pos: 6,  anunciante: 'CORPORACION JAAR', inv: 1407822, spots: 2589, origen: 'D' },
      { pos: 7,  anunciante: 'INFARMA', inv: 1330144, spots: 5250, origen: 'D' },
      { pos: 8,  anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 1287465, spots: 4157, origen: 'D' },
      { pos: 9,  anunciante: 'CORPORACION DINANT', inv: 1202405, spots: 4143, origen: 'D' },
      { pos: 10, anunciante: 'FARMACIA REGIS', inv: 1162525, spots: 2262, origen: 'D' },
      { pos: 11, anunciante: 'CARRION', inv: 1058690, spots: 2544, origen: 'D' },
      { pos: 12, anunciante: 'GRUPO SALINAS', inv: 862969, spots: 2734, origen: 'T' },
      { pos: 13, anunciante: 'HOSPITAL SAN JORGE', inv: 855093, spots: 1321, origen: 'D' },
      { pos: 14, anunciante: 'LARACH Y CIA', inv: 849428, spots: 2889, origen: 'D' },
      { pos: 15, anunciante: 'LOTELHSA', inv: 849356, spots: 3077, origen: 'D' },
      { pos: 16, anunciante: 'DIDEMO', inv: 846642, spots: 1744, origen: 'D' },
      { pos: 17, anunciante: 'BETCRIS.COM', inv: 835879, spots: 4662, origen: 'T' },
      { pos: 18, anunciante: 'CORPORACION LADY LEE', inv: 797323, spots: 1923, origen: 'D' },
      { pos: 19, anunciante: 'GRUPO MONGE', inv: 749331, spots: 2738, origen: 'T' },
      { pos: 20, anunciante: 'ALCALDIA DEL DISTRITO CENTRAL', inv: 664486, spots: 1204, origen: 'G' },
      { pos: 21, anunciante: 'HONDUBET', inv: 609878, spots: 2579, origen: 'T' },
      { pos: 22, anunciante: 'FARMAMEDICA', inv: 606503, spots: 1411, origen: 'T' },
      { pos: 23, anunciante: 'DIUNSA', inv: 546205, spots: 1953, origen: 'D' },
      { pos: 24, anunciante: 'CREATEX CREACIONES TEXTILES', inv: 541000, spots: 608, origen: 'D' },
      { pos: 25, anunciante: 'FARMACIAS DEL AHORRO', inv: 537654, spots: 2335, origen: 'D' },
    ],
  },
  'canal-11': {
    canal: 'CANAL 11',
    total: 47551917,
    totalSpots: 98124,
    data: [
      { pos: 1,  anunciante: 'GRUPO CONTINENTAL', inv: 8690606, spots: 18306, origen: 'D' },
      { pos: 2,  anunciante: 'DIUNSA', inv: 2531576, spots: 3797, origen: 'D' },
      { pos: 3,  anunciante: 'CELTEL', inv: 2488754, spots: 2722, origen: 'T' },
      { pos: 4,  anunciante: 'COLGATE PALMOLIVE', inv: 2364318, spots: 6745, origen: 'T' },
      { pos: 5,  anunciante: 'HASAN', inv: 1579561, spots: 2215, origen: 'D' },
      { pos: 6,  anunciante: 'CORPORACION DINANT', inv: 1543123, spots: 4527, origen: 'D' },
      { pos: 7,  anunciante: 'BAC CREDOMATIC', inv: 1541739, spots: 2520, origen: 'T' },
      { pos: 8,  anunciante: 'PEPSICO', inv: 1163171, spots: 3021, origen: 'T' },
      { pos: 9,  anunciante: 'UNICOMER', inv: 1113555, spots: 1658, origen: 'T' },
      { pos: 10, anunciante: 'UNILEVER', inv: 1098979, spots: 1792, origen: 'D' },
      { pos: 11, anunciante: 'CERVECERIA HONDUREÑA', inv: 921559, spots: 1634, origen: 'D' },
      { pos: 12, anunciante: 'INSTITUTO DE LA PROPIEDAD', inv: 804617, spots: 1391, origen: 'G' },
      { pos: 13, anunciante: 'PARTIDO LIBRE', inv: 702859, spots: 588, origen: 'P' },
      { pos: 14, anunciante: 'FARMA FACIL', inv: 621618, spots: 909, origen: 'D' },
      { pos: 15, anunciante: 'BMP SHOW', inv: 605058, spots: 1194, origen: 'D' },
      { pos: 16, anunciante: 'MOLINO HARINERO SULA', inv: 578638, spots: 697, origen: 'D' },
      { pos: 17, anunciante: 'WALMART OPERADORA DEL ORIENTE', inv: 551401, spots: 3236, origen: 'T' },
      { pos: 18, anunciante: 'EMBOTELLADORA DE SULA', inv: 546472, spots: 1160, origen: 'T' },
      { pos: 19, anunciante: 'PRESIDENCIA DE LA REPUBLICA', inv: 540901, spots: 422, origen: 'G' },
      { pos: 20, anunciante: 'UNIVERSIDAD DE SAN PEDRO SULA', inv: 491514, spots: 604, origen: 'D' },
      { pos: 21, anunciante: 'CARGILL', inv: 399324, spots: 1368, origen: 'T' },
      { pos: 22, anunciante: 'PROCTER AND GAMBLE', inv: 395424, spots: 664, origen: 'T' },
      { pos: 23, anunciante: 'ABBOTT LABORATORIOS', inv: 370551, spots: 551, origen: 'T' },
      { pos: 24, anunciante: 'MEAD JOHNSON', inv: 359024, spots: 839, origen: 'T' },
      { pos: 25, anunciante: 'CONEANFO', inv: 353380, spots: 436, origen: 'D' },
    ],
  },
  'telesistema-3y7': {
    canal: 'TELESISTEMA 3Y7',
    total: 47400129,
    totalSpots: 118321,
    data: [
      { pos: 1,  anunciante: 'GRUPO INTUR', inv: 5900407, spots: 8946, origen: 'D' },
      { pos: 2,  anunciante: 'LOTELHSA', inv: 3081325, spots: 7282, origen: 'D' },
      { pos: 3,  anunciante: 'GENOMMA LAB', inv: 2659168, spots: 4815, origen: 'T' },
      { pos: 4,  anunciante: 'CORPORACION DINANT', inv: 1399694, spots: 3215, origen: 'D' },
      { pos: 5,  anunciante: 'SUPERMERCADOS LA COLONIA', inv: 1194660, spots: 1636, origen: 'D' },
      { pos: 6,  anunciante: 'SERCOM DE HONDURAS', inv: 1027353, spots: 2342, origen: 'T' },
      { pos: 7,  anunciante: 'GRUPO SALINAS', inv: 947963, spots: 3609, origen: 'T' },
      { pos: 8,  anunciante: 'FARMAMEDICA', inv: 911024, spots: 2573, origen: 'T' },
      { pos: 9,  anunciante: 'FARMACITY', inv: 895277, spots: 1248, origen: 'D' },
      { pos: 10, anunciante: 'HONDUBET', inv: 876056, spots: 3709, origen: 'T' },
      { pos: 11, anunciante: 'UNICOMER', inv: 845225, spots: 2272, origen: 'T' },
      { pos: 12, anunciante: 'INFARMA', inv: 778390, spots: 1961, origen: 'D' },
      { pos: 13, anunciante: 'PEPE JEANS', inv: 768828, spots: 790, origen: 'D' },
      { pos: 14, anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 738033, spots: 2331, origen: 'D' },
      { pos: 15, anunciante: 'CERVECERIA HONDUREÑA', inv: 735291, spots: 989, origen: 'D' },
      { pos: 16, anunciante: 'COOPERATIVA CHOROTEGA', inv: 681987, spots: 1683, origen: 'D' },
      { pos: 17, anunciante: 'UNIMERC', inv: 638884, spots: 1037, origen: 'T' },
      { pos: 18, anunciante: 'CELTEL', inv: 599684, spots: 1745, origen: 'T' },
      { pos: 19, anunciante: 'INFASA', inv: 575297, spots: 4618, origen: 'D' },
      { pos: 20, anunciante: 'BAC CREDOMATIC', inv: 546886, spots: 1389, origen: 'T' },
      { pos: 21, anunciante: 'CENTRO OFTALMOLOGICO SANTA LUCIA', inv: 535904, spots: 1069, origen: 'D' },
      { pos: 22, anunciante: 'BANCO ATLANTIDA', inv: 533561, spots: 1259, origen: 'D' },
      { pos: 23, anunciante: 'BANCO CUSCATLAN', inv: 522028, spots: 1203, origen: 'T' },
      { pos: 24, anunciante: 'CARRION', inv: 517579, spots: 797, origen: 'D' },
      { pos: 25, anunciante: 'FANTASY LEAGUE HONDURAS', inv: 516527, spots: 870, origen: 'D' },
    ],
  },
  'telecadena-7y4': {
    canal: 'TELECADENA 7Y4',
    total: 22183618,
    totalSpots: 58781,
    data: [
      { pos: 1,  anunciante: 'GRUPO INTUR', inv: 2568209, spots: 5206, origen: 'D' },
      { pos: 2,  anunciante: 'GENOMMA LAB', inv: 1094631, spots: 2966, origen: 'T' },
      { pos: 3,  anunciante: 'CELTEL', inv: 934043, spots: 1370, origen: 'T' },
      { pos: 4,  anunciante: 'CORPORACION DINANT', inv: 820879, spots: 2469, origen: 'D' },
      { pos: 5,  anunciante: 'SUPERMERCADOS LA COLONIA', inv: 805972, spots: 1356, origen: 'D' },
      { pos: 6,  anunciante: 'FARMAMEDICA', inv: 780855, spots: 2199, origen: 'T' },
      { pos: 7,  anunciante: 'PROIMA HONDURAS', inv: 751993, spots: 981, origen: 'D' },
      { pos: 8,  anunciante: 'SERCOM DE HONDURAS', inv: 651319, spots: 1820, origen: 'T' },
      { pos: 9,  anunciante: 'BANCO ATLANTIDA', inv: 612637, spots: 1726, origen: 'D' },
      { pos: 10, anunciante: 'LOTELHSA', inv: 553991, spots: 2650, origen: 'D' },
      { pos: 11, anunciante: 'UNIMERC', inv: 447610, spots: 509, origen: 'T' },
      { pos: 12, anunciante: 'INFASA', inv: 433390, spots: 1002, origen: 'D' },
      { pos: 13, anunciante: 'LABORATORIOS QUIMIFAR', inv: 421639, spots: 577, origen: 'D' },
      { pos: 14, anunciante: 'IMSA', inv: 409437, spots: 801, origen: 'D' },
      { pos: 15, anunciante: 'UNICOMER', inv: 407859, spots: 2675, origen: 'T' },
      { pos: 16, anunciante: 'BAC CREDOMATIC', inv: 401800, spots: 1040, origen: 'T' },
      { pos: 17, anunciante: 'FUNDACION TELETON', inv: 371346, spots: 640, origen: 'D' },
      { pos: 18, anunciante: 'BANCO DE OCCIDENTE', inv: 341514, spots: 858, origen: 'D' },
      { pos: 19, anunciante: 'BANPAIS', inv: 324561, spots: 719, origen: 'D' },
      { pos: 20, anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 313717, spots: 1358, origen: 'D' },
      { pos: 21, anunciante: 'CARRION', inv: 308403, spots: 1182, origen: 'D' },
      { pos: 22, anunciante: 'CORPORACION JAAR', inv: 298749, spots: 405, origen: 'D' },
      { pos: 23, anunciante: 'NESTLE', inv: 298251, spots: 776, origen: 'T' },
      { pos: 24, anunciante: 'DIUNSA', inv: 285740, spots: 580, origen: 'D' },
      { pos: 25, anunciante: 'CARGILL', inv: 274978, spots: 948, origen: 'T' },
    ],
  },
  'canal-10': {
    canal: 'CANAL 10',
    total: 18017425,
    totalSpots: 91841,
    data: [
      { pos: 1,  anunciante: 'LABORATORIOS QUIMIFAR', inv: 2939985, spots: 14459, origen: 'D' },
      { pos: 2,  anunciante: 'BANCO ATLANTIDA', inv: 2420522, spots: 14131, origen: 'D' },
      { pos: 3,  anunciante: 'IMSA', inv: 1968562, spots: 11799, origen: 'D' },
      { pos: 4,  anunciante: 'CARRION', inv: 1348275, spots: 7109, origen: 'D' },
      { pos: 5,  anunciante: 'SERCOM DE HONDURAS', inv: 1188463, spots: 5063, origen: 'T' },
      { pos: 6,  anunciante: 'CENTRO DE CANCER ENMA ROMERO DE CALLEJAS', inv: 1057919, spots: 4139, origen: 'D' },
      { pos: 7,  anunciante: 'DON YAB', inv: 1004760, spots: 4727, origen: 'D' },
      { pos: 8,  anunciante: 'CENTRO OFTALMOLOGICO SANTA LUCIA', inv: 579653, spots: 5182, origen: 'D' },
      { pos: 9,  anunciante: 'EDITORIAL HABLEMOS CLARO', inv: 525040, spots: 2911, origen: 'D' },
      { pos: 10, anunciante: 'BAC CREDOMATIC', inv: 497718, spots: 3689, origen: 'T' },
      { pos: 11, anunciante: 'BANPAIS', inv: 391620, spots: 1185, origen: 'D' },
      { pos: 12, anunciante: 'BANRURAL', inv: 373402, spots: 1146, origen: 'T' },
      { pos: 13, anunciante: 'COHEP', inv: 303972, spots: 1152, origen: 'D' },
      { pos: 14, anunciante: 'UNIVERSIDAD METROPOLITANA DE HONDURAS', inv: 271331, spots: 643, origen: 'D' },
      { pos: 15, anunciante: 'FUNDACION TELETON', inv: 235661, spots: 950, origen: 'D' },
      { pos: 16, anunciante: 'ESPRESSO AMERICANO', inv: 222409, spots: 932, origen: 'D' },
      { pos: 17, anunciante: 'CASA JAAR.', inv: 215430, spots: 335, origen: 'D' },
      { pos: 18, anunciante: 'AMIGDOCAINA', inv: 189374, spots: 1003, origen: 'D' },
      { pos: 19, anunciante: 'CELTEL', inv: 151780, spots: 392, origen: 'T' },
      { pos: 20, anunciante: 'OEI ORGANIZACION DE ESTADOS IBEROAMERICANOS', inv: 148981, spots: 280, origen: 'T' },
      { pos: 21, anunciante: 'BANCO DE OCCIDENTE', inv: 145587, spots: 3438, origen: 'D' },
      { pos: 22, anunciante: 'UNIVERSIDAD POLITECNICA DE INGENIERIA', inv: 131467, spots: 281, origen: 'D' },
      { pos: 23, anunciante: 'PARTIDO LIBERAL DE HONDURAS', inv: 114225, spots: 328, origen: 'P' },
      { pos: 24, anunciante: 'CARGILL', inv: 107582, spots: 733, origen: 'T' },
      { pos: 25, anunciante: 'CATALYSIS', inv: 104610, spots: 437, origen: 'D' },
    ],
  },
  'vtv': {
    canal: 'VTV',
    total: 8882984,
    totalSpots: 33243,
    data: [
      { pos: 1,  anunciante: 'CELTEL', inv: 1715410, spots: 3616, origen: 'T' },
      { pos: 2,  anunciante: 'EMBAJADA DE ESTADOS UNIDOS', inv: 592068, spots: 1595, origen: 'T' },
      { pos: 3,  anunciante: 'SERCOM DE HONDURAS', inv: 518321, spots: 3621, origen: 'T' },
      { pos: 4,  anunciante: 'UNILEVER', inv: 498746, spots: 1232, origen: 'D' },
      { pos: 5,  anunciante: 'WALMART OPERADORA DEL ORIENTE', inv: 401345, spots: 4738, origen: 'T' },
      { pos: 6,  anunciante: 'CLEAN XTREME', inv: 378282, spots: 1511, origen: 'D' },
      { pos: 7,  anunciante: 'ROBIS', inv: 332670, spots: 816, origen: 'D' },
      { pos: 8,  anunciante: 'ABBOTT LABORATORIOS', inv: 295513, spots: 916, origen: 'T' },
      { pos: 9,  anunciante: 'GRUPO EPS', inv: 285890, spots: 496, origen: 'D' },
      { pos: 10, anunciante: 'SHERWIN WILLIAMS', inv: 279788, spots: 1025, origen: 'T' },
      { pos: 11, anunciante: 'CORPORACION DINANT', inv: 268379, spots: 1137, origen: 'D' },
      { pos: 12, anunciante: 'PARTIDO LIBRE', inv: 232516, spots: 347, origen: 'P' },
      { pos: 13, anunciante: 'DIUNSA', inv: 230442, spots: 527, origen: 'D' },
      { pos: 14, anunciante: 'BANCO ATLANTIDA', inv: 192629, spots: 519, origen: 'D' },
      { pos: 15, anunciante: 'PROCTER AND GAMBLE', inv: 184019, spots: 534, origen: 'T' },
      { pos: 16, anunciante: 'LABORATORIO MERCK', inv: 174613, spots: 599, origen: 'T' },
      { pos: 17, anunciante: 'CATALYSIS', inv: 168750, spots: 417, origen: 'D' },
      { pos: 18, anunciante: 'ZUMBATHON', inv: 164034, spots: 468, origen: 'D' },
      { pos: 19, anunciante: 'GLAXO SMITHKLINE', inv: 160093, spots: 825, origen: 'T' },
      { pos: 20, anunciante: 'LABORATORIO MK', inv: 148324, spots: 570, origen: 'T' },
      { pos: 21, anunciante: 'GRUPO TERRA', inv: 132966, spots: 423, origen: 'T' },
      { pos: 22, anunciante: 'SANCELA', inv: 104416, spots: 657, origen: 'T' },
      { pos: 23, anunciante: 'GLUCERNA', inv: 96061, spots: 297, origen: 'T' },
      { pos: 24, anunciante: 'ALMACENES EL TITAN', inv: 88154, spots: 348, origen: 'D' },
      { pos: 25, anunciante: 'BANPAIS', inv: 77211, spots: 350, origen: 'D' },
    ],
  },
  'azteca-honduras': {
    canal: 'AZTECA HONDURAS',
    total: 7553755,
    totalSpots: 71172,
    data: [
      { pos: 1,  anunciante: 'GRUPO SALINAS', inv: 1921331, spots: 26078, origen: 'T' },
      { pos: 2,  anunciante: 'AZTECA HONDURAS', inv: 1851852, spots: 7831, origen: 'T' },
      { pos: 3,  anunciante: 'PANI', inv: 703633, spots: 5986, origen: 'G' },
      { pos: 4,  anunciante: 'PANIPLAY', inv: 574403, spots: 5107, origen: 'D' },
      { pos: 5,  anunciante: 'PROCTER AND GAMBLE', inv: 373044, spots: 5402, origen: 'T' },
      { pos: 6,  anunciante: 'BAC CREDOMATIC', inv: 345238, spots: 1615, origen: 'T' },
      { pos: 7,  anunciante: 'CELTEL', inv: 236802, spots: 1639, origen: 'T' },
      { pos: 8,  anunciante: 'BANCO ATLANTIDA', inv: 160833, spots: 3441, origen: 'D' },
      { pos: 9,  anunciante: 'BMP SHOW', inv: 159756, spots: 993, origen: 'D' },
      { pos: 10, anunciante: 'CORPORACION DINANT', inv: 77060, spots: 742, origen: 'D' },
      { pos: 11, anunciante: 'SERCOM DE HONDURAS', inv: 67640, spots: 576, origen: 'T' },
      { pos: 12, anunciante: 'FUNDACION TELETON', inv: 52354, spots: 335, origen: 'D' },
      { pos: 13, anunciante: 'PLAY LAND PARK', inv: 52144, spots: 365, origen: 'D' },
      { pos: 14, anunciante: 'HONDUBET', inv: 51632, spots: 584, origen: 'T' },
      { pos: 15, anunciante: 'ROBIS', inv: 51190, spots: 429, origen: 'D' },
      { pos: 16, anunciante: 'WALT DISNEY COMPANY', inv: 47258, spots: 351, origen: 'T' },
      { pos: 17, anunciante: 'BANCO DE OCCIDENTE', inv: 46599, spots: 792, origen: 'D' },
      { pos: 18, anunciante: 'GLAXO SMITHKLINE', inv: 46069, spots: 739, origen: 'T' },
      { pos: 19, anunciante: 'MARATON DEL ATLANTICO', inv: 41370, spots: 280, origen: 'D' },
      { pos: 20, anunciante: 'UNILEVER', inv: 37081, spots: 227, origen: 'D' },
      { pos: 21, anunciante: 'SHERWIN WILLIAMS', inv: 35818, spots: 632, origen: 'T' },
      { pos: 22, anunciante: 'SUPERMERCADOS LA COLONIA', inv: 33624, spots: 287, origen: 'D' },
      { pos: 23, anunciante: 'FARMA FACIL', inv: 33394, spots: 291, origen: 'D' },
      { pos: 24, anunciante: 'SONY', inv: 32065, spots: 256, origen: 'D' },
      { pos: 25, anunciante: 'MONDELEZ HONDURAS', inv: 29826, spots: 381, origen: 'T' },
    ],
  },
  'qhubotv': {
    canal: 'QHUBOTV',
    total: 7407249,
    totalSpots: 109476,
    data: [
      { pos: 1,  anunciante: 'SERCOM DE HONDURAS', inv: 932257, spots: 20764, origen: 'T' },
      { pos: 2,  anunciante: 'CELTEL', inv: 872558, spots: 12009, origen: 'T' },
      { pos: 3,  anunciante: 'AUTOLLANTAS', inv: 679936, spots: 6585, origen: 'D' },
      { pos: 4,  anunciante: 'LABORATORIOS FINLAY', inv: 574779, spots: 9657, origen: 'D' },
      { pos: 5,  anunciante: 'FARMA FACIL', inv: 398613, spots: 5096, origen: 'D' },
      { pos: 6,  anunciante: 'FUMIZA', inv: 380829, spots: 4637, origen: 'D' },
      { pos: 7,  anunciante: 'BANCO DE OCCIDENTE', inv: 350217, spots: 4821, origen: 'D' },
      { pos: 8,  anunciante: 'PARTIDO NACIONAL DE HONDURAS', inv: 321074, spots: 2851, origen: 'P' },
      { pos: 9,  anunciante: 'UNIVERSIDAD METROPOLITANA DE HONDURAS', inv: 260638, spots: 1452, origen: 'D' },
      { pos: 10, anunciante: 'BAC CREDOMATIC', inv: 225490, spots: 3946, origen: 'T' },
      { pos: 11, anunciante: 'PARTIDO DEMOCRATA CRISTIANO', inv: 224255, spots: 1716, origen: 'P' },
      { pos: 12, anunciante: 'CLINICA SHENALU', inv: 183132, spots: 1398, origen: 'D' },
      { pos: 13, anunciante: 'PARTIDO LIBRE', inv: 173489, spots: 1003, origen: 'P' },
      { pos: 14, anunciante: 'ALCALDIA DEL DISTRITO CENTRAL', inv: 114049, spots: 1605, origen: 'G' },
      { pos: 15, anunciante: 'ALERGIL TRIPLE ACCION', inv: 111476, spots: 1604, origen: 'D' },
      { pos: 16, anunciante: 'PARTIDO LIBERAL DE HONDURAS', inv: 96331, spots: 1032, origen: 'P' },
      { pos: 17, anunciante: 'CAMPAÑA SALVADOR NASRALLA PRESIDENTE', inv: 84900, spots: 415, origen: 'D' },
      { pos: 18, anunciante: 'PARTIDO CAMBIEMOS HONDURAS', inv: 84533, spots: 903, origen: 'D' },
      { pos: 19, anunciante: 'PARTIDO LIBERAL', inv: 81569, spots: 739, origen: 'P' },
      { pos: 20, anunciante: 'LACTHOSA', inv: 73676, spots: 929, origen: 'D' },
      { pos: 21, anunciante: 'RAP', inv: 66223, spots: 1023, origen: 'D' },
      { pos: 22, anunciante: 'PLAY LAND PARK', inv: 66060, spots: 593, origen: 'D' },
      { pos: 23, anunciante: 'INVERSIONES LA PAZ', inv: 63711, spots: 476, origen: 'D' },
      { pos: 24, anunciante: 'INSTITUTO DE LA PROPIEDAD', inv: 56808, spots: 1271, origen: 'G' },
      { pos: 25, anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 56080, spots: 1088, origen: 'D' },
    ],
  },
  'deportes-tvc': {
    canal: 'DEPORTES TVC',
    total: 5358688,
    totalSpots: 39415,
    data: [
      { pos: 1,  anunciante: 'HONDUBET', inv: 815682, spots: 7204, origen: 'T' },
      { pos: 2,  anunciante: 'SERCOM DE HONDURAS', inv: 642007, spots: 3458, origen: 'T' },
      { pos: 3,  anunciante: 'LOTELHSA', inv: 564311, spots: 4925, origen: 'D' },
      { pos: 4,  anunciante: 'FARMAMEDICA', inv: 342177, spots: 2136, origen: 'T' },
      { pos: 5,  anunciante: 'GRUPO INTUR', inv: 301031, spots: 1754, origen: 'D' },
      { pos: 6,  anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 277919, spots: 2644, origen: 'D' },
      { pos: 7,  anunciante: 'INFARMA', inv: 257059, spots: 1837, origen: 'D' },
      { pos: 8,  anunciante: 'CERVECERIA HONDUREÑA', inv: 176203, spots: 911, origen: 'D' },
      { pos: 9,  anunciante: 'PANIPLAY', inv: 171293, spots: 1048, origen: 'D' },
      { pos: 10, anunciante: 'INFASA', inv: 111670, spots: 769, origen: 'D' },
      { pos: 11, anunciante: 'FANTASY LEAGUE HONDURAS', inv: 104389, spots: 447, origen: 'D' },
      { pos: 12, anunciante: 'PRESIDENCIA DE LA REPUBLICA', inv: 100625, spots: 329, origen: 'G' },
      { pos: 13, anunciante: 'CD OLIMPIA', inv: 89589, spots: 249, origen: 'D' },
      { pos: 14, anunciante: 'CARRION', inv: 87119, spots: 596, origen: 'D' },
      { pos: 15, anunciante: 'CORPORACION DINANT', inv: 86066, spots: 767, origen: 'D' },
      { pos: 16, anunciante: 'GRUPO TERRA', inv: 82467, spots: 760, origen: 'T' },
      { pos: 17, anunciante: 'BETPRO', inv: 81720, spots: 618, origen: 'D' },
      { pos: 18, anunciante: 'YUUJU APP', inv: 50862, spots: 281, origen: 'D' },
      { pos: 19, anunciante: 'BETCRIS.COM', inv: 48100, spots: 259, origen: 'T' },
      { pos: 20, anunciante: 'DILO BILLETERA DIGITAL', inv: 45593, spots: 247, origen: 'D' },
      { pos: 21, anunciante: 'BAC CREDOMATIC', inv: 45569, spots: 288, origen: 'T' },
      { pos: 22, anunciante: 'ESPECTACULARES HNOS FUENTES GASCA', inv: 41116, spots: 83, origen: 'T' },
      { pos: 23, anunciante: 'BANCO ATLANTIDA', inv: 39765, spots: 389, origen: 'D' },
      { pos: 24, anunciante: 'FARMACITY', inv: 38086, spots: 322, origen: 'D' },
      { pos: 25, anunciante: 'COOPERATIVA ELGA', inv: 37809, spots: 214, origen: 'D' },
    ],
  },
};

export default CANAL_DATA;
